var _path, _path2, _path3, _path4, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAppleWalletDownload(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 47,
    height: 48,
    viewBox: "0 0 47 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30.1894 21.998H25.9994V5.99805C25.9994 5.44605 25.5514 4.99805 24.9994 4.99805H20.9994C20.4474 4.99805 19.9994 5.44605 19.9994 5.99805V21.998H15.8094C15.0894 21.998 14.7294 22.868 15.2384 23.377L21.9394 30.078C22.5254 30.664 23.4754 30.664 24.0604 30.078L30.7614 23.377C31.2704 22.868 30.9094 21.998 30.1894 21.998Z",
    fill: "url(#paint0_linear_3089_103896)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M38 32.998V42.998L42.828 38.17C43.578 37.42 44 36.402 44 35.342V32.998C44 32.446 43.552 31.998 43 31.998H39C38.448 31.998 38 32.446 38 32.998Z",
    fill: "url(#paint1_linear_3089_103896)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M38 36.998H8V42.998H38V36.998Z",
    fill: "#054ED8"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M8 32.998V42.998L3.172 38.17C2.421 37.419 2 36.402 2 35.341V32.998C2 32.446 2.448 31.998 3 31.998H7C7.552 31.998 8 32.446 8 32.998Z",
    fill: "url(#paint2_linear_3089_103896)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_3089_103896",
    x1: 16.3334,
    y1: 4.70305,
    x2: 28.4914,
    y2: 32.951,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0851DC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1F6CFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_3089_103896",
    x1: 38.5,
    y1: 31.8709,
    x2: 44.2358,
    y2: 43.465,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0851DC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1F6CFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_3089_103896",
    x1: 2.50004,
    y1: 31.8709,
    x2: 8.23578,
    y2: 43.465,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0851DC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1F6CFF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAppleWalletDownload);
export default __webpack_public_path__ + "static/media/apple Wallet Download.2ef640be3b2e38beb1ff25f73f0b186d.svg";
export { ForwardRef as ReactComponent };